import { render, staticRenderFns } from "./DoctorListEmpty.vue?vue&type=template&id=56a59bba&"
import script from "./DoctorListEmpty.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorListEmpty.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a59bba')) {
      api.createRecord('56a59bba', component.options)
    } else {
      api.reload('56a59bba', component.options)
    }
    module.hot.accept("./DoctorListEmpty.vue?vue&type=template&id=56a59bba&", function () {
      api.rerender('56a59bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/memorial/MemoryBoardPage/components/DoctorListEmpty.vue"
export default component.exports